import * as React from 'react';

export default function CtaButton(props) {
  const {text, url, target} = props;

  if (!text || `${text}`.trim() === '' || !url || `${url}`.trim() === '') {
    return null;
  }

  return (
    <a href={url} target={target} className='btn btn-cta nv-banner__cta'>{text}</a>
  );
}
